module.exports = __webpack_public_path__ + "img/user-icon.05a72a0d0ab288c12b766759d051cb1d.png";